{
  "id": "ayu",
  "name": "Ayu",
  "description": "Ayu color scheme - beautiful and modern theme",
  "colors": {
    "light": {
      "primary": "#36A3D9",
      "secondary": "#A37ACC",
      "positive": "#86B300",
      "negative": "#F07178",
      "warning": "#F2AE49",
      "important": "#E6B450",
      "light": "#FFFFFF",
      "dark": "#3f3f46",
      "surface": "#FAFAFA",
      "darksurface": "#1A1F2E",
      "white": "#F8F9FA"
    },
    "dark": {
      "primary": "#61AFEF",
      "secondary": "#AE81FF",
      "positive": "#8EB03E",
      "negative": "#F07178",
      "warning": "#FFB454",
      "important": "#FFA759",
      "light": "#FFFFFF",
      "dark": "#0F1419",
      "surface": "#FAFAFA",
      "darksurface": "#1A1F2E",
      "white": "#E6E1CF"
    }
  }
}
